const getPublishUrl = (domain) =>
  domain
    ? `${window.location.origin}/publish?domain=${domain}`
    : `${window.location.origin}/publish`;

export default getPublishUrl;
